var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "600px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: {
            "label-width": "100px",
            "label-position": "left",
            disabled: !_vm.editable
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CooperateBranchId"))
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "branchId",
                          "select-type": _vm.TYPE_NAMES.basic_data_Office,
                          clearable: false,
                          filterable: "",
                          "default-value": Number(_vm.job.branchId),
                          cache: false,
                          "static-options": _vm.officeList,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.branchId = p.value
                            _vm.reSet()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_CooperateBusinessType")
                            )
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "businessType",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CooperationType,
                          multiple: true,
                          clearable: false,
                          filterable: "",
                          "default-multiple-value": _vm.job.businessType,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.businessType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                      ),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "opId",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.opId || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opId = p.value
                            _vm.opChangeHandler(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "csrId",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.job.csrId || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "overseaOp",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "overseaOp"
                          },
                          "default-value": _vm.job.overseaOp || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.overseaOp = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "dcId",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.job.dcId || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "seaLine"
                          },
                          "default-value": _vm.job.planner || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.planner = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Sales") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "sales",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "sales"
                          },
                          "default-value": _vm.job.sales || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.salesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.job.cargoSalesId || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "userDefinedRole1",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "userDefinedRole2",
                          "method-params": {
                            officeId: _vm.job.branchId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ProfitShare") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "profitShare" },
                          model: {
                            value: _vm.job.profitShare,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "profitShare", $$v)
                            },
                            expression: "job.profitShare"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: true
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: false
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", no: "remark", rows: 4 },
                        model: {
                          value: _vm.job.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remark", $$v)
                          },
                          expression: "job.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editable,
                  expression: "editable"
                }
              ],
              attrs: { type: "primary", no: "confirm" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: _vm.editable ? "" : "primary", no: "cancel" },
              on: { click: _vm.handleClose }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }